export default __webpack_public_path__ + "static/media/vision.720cab44.png";